<tp-page-scaffold [pageAvailability]="availability$ | async">
  <article>
    <div class="section-title-row">
      <a class="back-button" routerLink="..">
        <i class="fa-light fa-arrow-left"></i>
      </a>
      <tp-logs-control-bar [title]="'Cluster logs (' + (cluster$ | async)!.id + ')'" (downloadLogs)="openDownloadLogsDialog()" (isStreamingEnabled$)="isStreamingEnabled = $event"/>
    </div>
    @if (hasMultipleServers$ | async) {
      <mat-tab-group (selectedIndexChange)="selectedTabIndex = $event">
        <mat-tab>
          <ng-template mat-tab-label>Combined</ng-template>
          <tp-cluster-logs-viewing-pane [isStreamingEnabled]="isStreamingEnabled"/>
        </mat-tab>
        @for (serverId of serverIds$ | async; track serverId) {
          <mat-tab>
            <ng-template mat-tab-label>Server {{ serverId }}</ng-template>
            <tp-server-logs-viewing-pane [isStreamingEnabled]="isStreamingEnabled" [serverId]="serverId"/>
          </mat-tab>
        }
      </mat-tab-group>
    } @else {
      <tp-server-logs-viewing-pane [isStreamingEnabled]="isStreamingEnabled" [serverId]="0"/>
    }
  </article>
</tp-page-scaffold>
